import lib from "./../../js-lib/lib.js";

const Images = {
  render: (state, selection) => {
    // Non-ECO / High Resoluton Images

    lib.qsa("[data-high-srcset]", selection).forEach((elem) => {
      if (
        state.theme.current == "light" ||
        (state.theme.current == "dark" && !elem.dataset.darkSrcset)
      ) {
        elem.setAttribute("srcset", elem.getAttribute("data-high-srcset"));
      }

      if (state.theme.current == "dark" && elem.dataset.darkSrcset) {
        elem.setAttribute("srcset", elem.getAttribute("data-dark-srcset"));
      }
    });

    setTimeout(() => {
      lib.qsa("img.res", selection).forEach((elem) => {
        if (elem.getAttribute("data-high-src") !== null) {
          //elem.setAttribute("src", elem.getAttribute("data-high-src"));

          if (
            state.theme.current == "light" ||
            (state.theme.current == "dark" && !elem.dataset.darkSrc)
          ) {
            elem.setAttribute("src", elem.getAttribute("data-high-src"));
          }

          if (state.theme.current == "dark" && elem.dataset.darkSrc) {
            elem.setAttribute("src", elem.getAttribute("data-dark-src"));
          }
        }
      });
    }, 1);
  },
  observer: (state) => {
    let lazyImages = [].slice.call(document.querySelectorAll("img.res"));

    let LazyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let selection = entry.target.parentNode;

          Images.render(state, selection);
        }
      });
    });

    lazyImages.forEach((img) => {
      LazyObserver.observe(img);
    });
  },
};

export { Images as default };
